import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articleContents';

const displayArticles = allArticles.slice(0, 6);

export default function ArticlePreview() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div>
            <span className="text-xs font-semibold text-foreground-500 uppercase tracking-[0.2em]">
              Latest Shopping Guides
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold italic text-foreground-900 mt-2">
              From Kakobuy Experts
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
            In-depth guides, honest comparisons, and safety tips written by experienced shoppers who use the Kakobuy Spreadsheet every day. Updated regularly with the latest finds and strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {displayArticles.map((article) => (
            <Link
              key={article.id}
              to={`/${article.slug}`}
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full h-[220px] overflow-hidden">
                <img
                  src={article.cardImage}
                  alt={article.cardImageAlt}
                  title={article.cardImageTitle}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-block text-[11px] font-semibold text-accent-700 bg-accent-100/80 px-2.5 py-1 rounded-md uppercase tracking-wider mb-3">
                  {article.category}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors duration-200 line-clamp-3">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 mt-2 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200/60">
                  <div className="flex flex-wrap gap-1.5">
                    {article.tags.slice(0, 2).map((tag) => (
                      <span key={tag} className="text-[11px] text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}